import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { createUserStorage } from "../storage/user-storage";

interface LanguageState {
  language: string;
  setLanguage: (language: string) => void;
  initializeFromUser: (userLanguage?: string) => void;
}

export const createLanguageStore = () => {
  return create<LanguageState>()(
    persist(
      (set, get) => ({
        language: "en-US",
        setLanguage: (language: string) => {
          set({ language });
        },
        initializeFromUser: (userLanguage?: string) => {
          if (userLanguage && userLanguage !== get().language) {
            set({ language: userLanguage });
          }
        },
      }),
      {
        name: "language",
        storage: createJSONStorage(() => createUserStorage()),
      }
    )
  );
};

export const languageStore = createLanguageStore();
export const useLanguageStore = languageStore;
